import React from 'react';
function SchoolHighlights() {  return (
    <section className="highlights" style={{ padding: "0" }}>
      <div className="wrap">
        <div className="highlights-grid">
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <path d="M22 10L12 4 2 10l10 6 10-6z"></path>
                <path d="M6 12v5c3 2 9 2 12 0v-5"></path>
              </svg>
            </div>
            <h4>{"Academic Excellence"}</h4>
            <p>{"Holistic, future-ready education"}</p>
          </div>
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <circle cx="9" cy="7" r="3"></circle>
                <path d="M2 20c0-3.5 3-6 7-6s7 2.5 7 6"></path>
                <path d="M17 9l4 2-4 2"></path>
              </svg>
            </div>
            <h4>{"Experienced Faculty"}</h4>
            <p>{"Passionate educators who inspire"}</p>
          </div>
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <rect x="4" y="9" width="16" height="12" rx="1"></rect>
                <path d="M9 21V13h6v8M4 9l8-6 8 6"></path>
              </svg>
            </div>
            <h4>{"Modern Campus"}</h4>
            <p>{"World-class facilities throughout"}</p>
          </div>
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <path d="M8 21h8M12 17v4M6 4h12v6a6 6 0 0 1-12 0V4z"></path>
                <path d="M6 6H3a3 3 0 0 0 3 5M18 6h3a3 3 0 0 1-3 5"></path>
              </svg>
            </div>
            <h4>{"Co-Curricular Activities"}</h4>
            <p>{"Sports, arts, and leadership"}</p>
          </div>
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <path d="M12 3l7 3v6c0 5-3 8-7 9-4-1-7-4-7-9V6l7-3z"></path>
              </svg>
            </div>
            <h4>{"Safe & Inclusive"}</h4>
            <p>{"A secure home for every child"}</p>
          </div>
          <div className="h-item">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#0E2A52" strokeWidth="1.8">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M3 12h18M12 3c2.5 2.5 4 6 4 9s-1.5 6.5-4 9c-2.5-2.5-4-6-4-9s1.5-6.5 4-9z"></path>
              </svg>
            </div>
            <h4>{"Global Perspective"}</h4>
            <p>{"Preparing students to lead worldwide"}</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SchoolHighlights;
